import baseReport from '../baseReportImpressao';
import Meses from '@/utils/dias';
import formatDataBR from '@/plugins/filters/formatDataBR';

const montarTableHeader = (periodos) => {
  return [
    [
      {
        text: 'Atividades Avaliativas',
        alignment: 'center',
        style: 'tableHeader',
      },
      ...periodos.map(key => ({ text: key.dspravadi, alignment: 'center', style: 'tableHeader' })),
    ],
  ];
};

const montarAssinatura = (professores, filtros, tipoDeEnsino) => {
  return [
    {
      columns: [
        { width: '*', text: '' },
        {
          width: 'auto',
          alignment: 'right',
          layout: 'noBorders',
          table: {
            body: [
                ...professores.map(key => ([{
                  alignment: 'center',
                  fontSize: 8,
                  margin: [15, 35, 15, 0],
                  text: [
                    '_____________________________________________\n',
                    'Assinatura do Professor/Educador\n',
                    `${key.nmfuncion}\n`,
                    `${key.cdpessoal}-${key.cdmatric}`
                  ],
                }])),
            ],
          },
        },
        { width: '*', text: '' },
      ],
    },
    {
      fontSize: 9,
      italics: true,
      margin: [0, 20, 0, 0],
      text: [{ text: 'Obs.: ', bold: true }, (filtros.aaletivo >= 2020 && tipoDeEnsino === 'I') ? 'Este relatório apresenta todas as atividades cadastradas correspondentes a campos de experiência.' : 'Este relatório apresenta todas as atividades cadastradas correspondentes a disciplina.'],
    },
  ];
};

const registroConceitoAnaliticoReport = async ({ date, time, filtros, alunos, conceitos, professores, periodos, exibirTotalGeral,tipoDeEnsino, indicaanoletivoexcedeu = 'N', anoSubsequente }) => {
  const headerFooter = await baseReport({ date, time, title: 'Diário de Classe', subTitle: 'Registro de Conceito Analítico' }, 'landscape');

  let nameProfessores = professores.reduce((total, key) => `${total}${key.nmfuncion.trim()}, `, '');
  nameProfessores = nameProfessores.substring(0, nameProfessores.length - 2);


  const AnoSubsquente = indicaanoletivoexcedeu === 'S' ? [ { text: '   Ano subsequente:   ', bold: true }, anoSubsequente ] :  []

  const filtrosFormated = [
    {
      text: filtros.nmescola,
      bold: true,
      fontSize: 12,
      alignment: 'center',
      margin: [0, 5, 0, 5],
    },
    {
      fontSize: 9,
      text: [
        { text: 'Professor/Educador:   ', bold: true },
        nameProfessores,
      ],
    },
    {
      fontSize: 9,
      columns: [
        {
          text: [
            { text: 'Ano letivo:  ', bold: true },
            filtros.aaletivo,
            ...AnoSubsquente
          ],
        },
        {
          alignment: 'right',
          text: [
            { text: 'Turma:   ', bold: true },
            filtros.turma,
          ],
        },
      ],
    },
    {
      fontSize: 9,
      columns: [
        {
          text: [
            { text: (filtros.aaletivo >=2020 && tipoDeEnsino === 'I') ? 'Campos de Experiência:   ' : 'Disciplina:   ', bold: true },
            filtros.disciplina
          ],
        },
        {},
      ],
    },
  ];

  if (alunos.length <= 0 || (alunos.length > 0 && alunos[0].atividades.length <= 0)) {
    return {
      ...headerFooter,
      ...filtrosFormated,
      content: [{
        text: 'Nenhum aluno com conceito encontrado.',
        fontSize: 10,
        alignment: 'center',
        margin: [0, 15, 0, 0],
        bold: true,
      }],
    };
  }

  let dataFormated = [];
  for(const aluno of alunos) {
    const linha = [
      ...aluno.atividades.map(key => {
        let conceitos = [];
        for(const index in key.conceitos) {
          conceitos.push({ text: key.conceitos[index], alignment: 'center', fontSize: 8 });
        }
        return [
          {
            text: key.descricaoatividadeavaliativa,
            fontSize: 8,
          },
          ...conceitos,
        ];
      }),
      [
        {
          text: 'Conceito do Período',
          style: 'tableHeader',
          alignment: 'center',
        },
        ...aluno.totalPeriodos.map(key => ({ style: 'tableHeader', text: key, alignment: 'center' })),
      ],
    ];

    let conceitoFinal = [];
    if(exibirTotalGeral && aluno.totalPeriodos.every(key => key !== '-')) {
      conceitoFinal.push({
        margin: [0, 6, 0, 0],
        fontSize: 10,
        alignment: 'right',
        text: [
          { text: 'Conceito Final:   ', bold: true },
          aluno.totalGeral,
        ],
      });
    }

    const tabela = [
      {
        margin: [0, 15, 0, 3],
        fontSize: 10,
        columns: [
          {
            width: '80%',
            text: [
              { text: 'Aluno:  ', bold: true },
              aluno.nmaluno + `${(aluno.invalido==='PDI')? ' - ' + aluno.invalido :''} - Dt Enturmacao: ${formatDataBR(aluno.dtsitalun)}${(aluno.invalido!='PDI' && aluno.invalido != null)? ' ' + aluno.invalido :''} ${(aluno.invalido!='PDI' && aluno.invalido != null )? ' - ' + formatDataBR(aluno.dtafastam) : ''}`,
            ],
          },
          {
            // alignment: 'right',
            // width: '20%',
            // text: aluno.invalido,
            // bold: true,
          }
        ],
      },
      {
        table: {
          widths: [
            { width: '*' },
            ...periodos.map(() => ({ width: 'auto' })),
          ],
          body: [
            ...montarTableHeader(periodos),
            ...linha,
          ],
        },
      },
      ...conceitoFinal,
    ];

    dataFormated.push(tabela);
  }

  return {
    ...headerFooter,
    content: [
      ...filtrosFormated,
      ...dataFormated,
      {
        margin: [0, 23, 0, 3],
        columns: [
          {
          },
          {
            width: '70%',
            alignment: 'right',
            table: {
              widths: ['30%', '70%'],
              body: [
                [
                  { text: 'Legenda',
                    colSpan: 2,
                    alignment: 'center',
                    bold: true,
                    fontSize: 8,
                    color: 'black',
                    fillColor: '#eeeeee', },
                  {},
                ],
                ...conceitos.map(key => ([
                  { text: key.valorconceito, fontSize: 8, alignment: 'center' },
                  { text: key.descricaoconceito, fontSize: 8, alignment: 'center' },
                ])),
              ],
            }
          },
        ],
      },
      ...montarAssinatura(professores, filtros, tipoDeEnsino),
    ],
    styles: {
      tableHeader: {
        bold: true,
        fontSize: 10,
        color: 'black',
        fillColor: '#eeeeee',
      },
    },
  };
};

export default registroConceitoAnaliticoReport;
